import React from "react";
import { Button, styled } from "@mui/material";

const CustomButton = (props) => {
  const { name, background, onClick } = props;
  const ButtonStyle = styled(Button)({
    background: background
      ? background
      : "linear-gradient(99.51deg, #21a9b0 -27.16%, #283679 110.14%), linear-gradient(98.7deg, #2aff9d -39.19%, #25e8a1 -9.06%, #0051ba 197.08%), #2a3478;",
    color: "#fff",
    padding: "5px 20px",
    ":hover": {
      color: "#000",
    },
  });
  return <ButtonStyle onClick={onClick}>{name}</ButtonStyle>;
};
export default CustomButton;
